module.exports = __webpack_public_path__ + "static/service_3-8f504fc846726dd7743e3d75853f87c7.jpg";